import request from '@/utils/request'

// 通用类型选项数据
export function findCommonTypeOptions(typeSlug, subTypeSlug) {
  const params = { type_slug: typeSlug }
  if (subTypeSlug) {
    params.sub_type_slug = subTypeSlug
  }
  return request({
    url: `/common_types/options`,
    method: 'get',
    params
  })
}
